export default __webpack_public_path__ + "static/media/pratima.9f67b9a3.png";